import React from 'react';

const translate = state => {
	const stateTranslate = {
		draft: 'Черновик',
		available: 'Опубликовано',
		deleted: 'Удалено',
	};
	return stateTranslate[state];
};

export const StatusCell = props => {
	return <div>{translate(props.state)}</div>;
};



// WEBPACK FOOTER //
// src/components/articles/columns/status.js